import MDBox from "components/MDs/MDBox";
import DashboardLayout from "../DashboardLayout";

function EmptyLayout() {

  return (
    <DashboardLayout>
      <MDBox pb={3}>

      </MDBox>
    </DashboardLayout>
  );
}

export default EmptyLayout;
